module.exports = __webpack_public_path__ + "img/symposium-2019.f6d174eb.jpg";